import Alpine from 'alpinejs';
import Store from 'store2';
const store = Store.namespace('media');

export default function () {
    let container = {posters: [], landscapes: [], heros: [], videos: [], subtitles: [], trailers: []};
    let all = store.get('completed_files') || [];
    for (let f of all) {
        container[f.type].push(f);
    }

    Alpine.store('media', {
        all_files: all,
        completed_files: all,

        posters: container.posters,
        landscapes: container.landscapes,
        heros: container.heros,

        videos: container.videos,
        subtitles: container.subtitles,
        trailers: container.trailers,

        update() {
            this.posters = [];
            this.landscapes = [];
            this.heros = [];
            this.videos = [];
            this.subtitles = [];
            this.trailers = [];

            this.all_files.filter((f) => this[f.type].push(f) );
        },
        addFile(f) {
            this.all_files.push(f);
            this.update();
            return this.dispatch(f);
        },
        updateFile(f) {
            let n = this.all_files.filter((file) => (file.id !== f.id));
            n.push(f);
            this.all_files = n;
            let el = $(`#${f.id}`);
            if (el.length === 1) {
                $('.status', el).text(f.status);
                let pel = $('.progress', el);
                console.log('UPDATING PROGRESS', f.progress, pel)
                pel.text(f.progress);

                el.attr('class', 'file');
                el.addClass(f.css_status || f.status.toLowerCase());
            }
            if (f && f.s3_file_id) {    
                let c = this.completed_files.filter((file) => (file.id !== f.id));
                c.push(f);
                this.completed_files = c;
                store.set('completed_files', this.completed_files);
            }
            this.update();
            if (f.s3_file_id != undefined)
            {
                var old_val = $('#s3_file_ids').val()
                $('#s3_file_ids').val(old_val+','+f.s3_file_id);
            }
            return this.dispatch(f);
        },

        files() {
            return this.all_files;
        },

        removeFile(f) {
            this.all_files = this.all_files.filter((file) => (f.id !== file.id));
            this.completed_files = this.completed_files.filter((file) => (f.id !== file.id));
            store.set('completed_files', this.completed_files);
            this.update();
            return this.dispatch(f);
        },

        dispatch(f) {
            const evt = new CustomEvent("file-update", { detail: f });
            window.dispatchEvent(evt);
        }
    })

    return Alpine.store('media');
}
